import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import { FaHeart } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import health from '../img/childh.avif'
import feed from '../img/food.avif'
import shelter from '../img/minsh.jpg'
import { Helmet } from 'react-helmet-async'

function Partners() {

    const navigate = useNavigate()
    const donationClick=()=>{
        navigate('/contact-us')
    }

    
    const data =[
        {
            title: 'Our Work In Emergencies',
            image: health,
            link: '/emergencies'
        },
        {
            title: 'Our Leadership',
            image: feed,
            link: '/our-leadership'
        },
        {
            title: 'Out impact',
            image: shelter,
            link: '/our-impact'
        },
    ]

  return (
    <>
        <Helmet>
            <title>Partner With Us | The Lord Nations Foundation</title>
            <meta name="description" content="Join hands with The Lord Nations Foundation to make a lasting impact. Explore partnership opportunities and collaborate with us to create positive change." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='partner_banner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>partner with us</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>
            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>CREATING LASTING CHANGE TOGETHER</h1>
                </div>

                <p>
                    At The Lord Nations Foundation, we’re working to change children’s futures for good. Our goals are ambitious and can only be met in partnership with others. 
                </p>

                <p>We work with a range of partners that help us achieve lasting change for children on a global scale.</p>
            </div>

            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>Get Involved</h2>
                </div>

                <p>
                Your support can change lives! Whether by donating, volunteering, or spreading awareness, you can be a part of this movement of hope.
                </p>

                <div className='about_donation_link'>
                    <h3>The Lord Nations Foundation WORKS WITH PARTNERS TO CREATE LASTING CHANGE FOR CHILDREN.</h3>
                    <div onClick={()=>donationClick()} className='about_header_donate_btn'>
                        <FaHeart className='desk_header_donate_btn_icon' />
                        <h3>DONATE</h3>
                    </div>
                </div>

                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>WHY PARTNER WITH The Lord Nations Foundation?</h2>
                </div>

                <p>
                    The Lord Nations Foundation cultivates innovative and meaningful partnerships with organisations that share our belief that every child has the same rights, and that realising these rights is the key to their future. We focus on long-term, mutually beneficial partnerships that benefit from our global presence. Our commitment to learning and comprehensive reporting ensures that our partners know and understand the impact of our collaboration.
                </p>

                
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>Learn more about Save the Children</h2>
                </div>
            </div>
            
            <div className='our_work_body'>
                {
                    data?.map((inf, i)=>(
                        <div onClick={()=> navigate(`${inf?.link}`)} key={i} className='our_work_body_img' style={{backgroundImage:`url(${inf?.image})`, backgroundRepeat:'no-repeat', backgroundSize:'cover', backgroundPosition:'center', position:'relative'}} >
                            <h3>{inf?.title}</h3>
                        </div>
                    ))
                }
            </div>
            
            <BottomBar/>
        </div>
    </>
  )
}

export default Partners